import styled from 'styled-components';

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  padding: 4rem;
  background: linear-gradient(135deg, rgb(0, 21, 41), rgb(0, 64, 128));

  h2 {
    font-size: 2rem;
    color: var(--yellow);
    margin-bottom: 2rem;
    text-align: center;
    position: relative;
    display: inline-block;
    
    &::after {
      content: '';
      position: absolute;
      width: 50%;
      height: 3px;
      bottom: -10px;
      left: 25%;
      background: var(--yellow);
      border-radius: 3px;
    }
  }

  hr {
    height: 1px;
    border: none;
    color: #ffd4206e;
    background-color: #ffd4206e;
  }

  p,
  a {
    color: var(--textWhite);
    font-size: 1.4rem;
  }

  & .footer-top {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: space-between;
    align-items: start;
    gap: 4rem;
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 5rem;
    }
  }

  & .footer-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    order: 1;
  }

  & .footer-middle {
    display: flex;
    flex-direction: column;
    align-items: center;
    order: 2;
    
    ul {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1.5rem;
      padding: 0;
      list-style: none;
    }
    
    li {
      width: 100%;
      text-align: center;
    }
    
    a {
      display: inline-block;
      padding: 1rem 2.5rem;
      color: #fff;
      text-transform: uppercase;
      font-size: 1.4rem;
      letter-spacing: 0.15rem;
      transition: all 0.3s;
      position: relative;
      overflow: hidden;
      z-index: 1;
      border: 2px solid var(--yellow);
      border-radius: 4px;
      text-decoration: none;
      min-width: 15rem;
      text-align: center;
      font-weight: 500;

      &:hover {
        color: #000;
        background: var(--yellow);
        transform: translateY(-3px);
        box-shadow: 0 10px 20px rgba(255, 212, 32, 0.2);
      }
    }
  }

  & .footer-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    order: 3;
    
    .contact-info {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      margin-top: 1rem;
    }
    
    .contact-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
      
      span {
        color: var(--yellow);
        font-weight: 600;
        font-size: 1.4rem;
      }
      
      a {
        color: var(--textWhite);
        text-decoration: none;
        transition: all 0.2s;
        text-align: center;
        font-size: 1.3rem;
        
        &:hover {
          color: var(--yellow);
          text-decoration: underline;
        }
      }
    }
  }

  & .footer-social-media__icons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3rem;
    margin-top: 1rem;
    
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;
      border-radius: 50%;
      padding: 0.5rem;
      
      &:hover {
        background: rgba(255, 212, 32, 0.1);
      }
    }
    
    svg {
      width: 3.5rem;
      height: 3.5rem;
      fill: var(--yellow);
      transition: all 0.2s ease;
      
      &:hover {
        transform: scale(1.2) translateY(-5px);
        filter: drop-shadow(0 5px 5px rgba(255, 212, 32, 0.3));
      }
    }
  }

  & .footer-bottom {
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    
    p {
      font-size: 1.3rem;
      opacity: 0.9;
      
      &:last-child {
        opacity: 0.7;
        font-size: 1.2rem;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 4rem 2rem;
    
    & .footer-top {
      grid-template-columns: 1fr;
      
      & > div {
        order: initial !important;
      }
    }
  }
`;